@use './variables.css';

.jb-time-picker-web-component {
    width: 272px;
    height: 272px;
    .svg-clock-wrapper {
        padding: 16px;
        .svg-clock {
            width: 100%;
            height: 100%;
            overflow: visible;
            .outer-circle {
                fill: var(--outer-circle-color);
            }

            .inner-circle {
                fill: var(--inner-circle-color);
            }

            .time-text-wrapper {
                .time-text {
                    font-size: 150px;
                    text-anchor: middle;
                    cursor: pointer;
                    user-select: none;
                    &.--hidden {
                        display: none;
                    }
                    &.--optional{
                        opacity: 0.6;
                    }
                }

                &.current-time {
                    .time-text {
                        fill: var(--current-text-color);
                        
                        &.--focused {
                            &.hour-text {
                                fill: var(--hour-color);
                            }

                            &.minute-text {
                                fill: var(--minute-color);
                            }

                            &.second-text {
                                fill: var(--second-color);
                            }
                        }
                    }

                    .separator-text {
                        font-size: 150px;
                        text-anchor: middle;
                        fill: var(--separator-text-color);
                        user-select: none;
                        &.--hidden {
                            display: none;
                        }
                    }
                }

                &.prev-time {
                    .time-text {
                        fill: var(--prev-text-color);
                    }
                }

                &.next-time {
                    .time-text {
                        fill: var(--next-text-color);
                    }
                }
            }

            .time-indicators {
                fill: var(--indicator-text-color);

                .hour-indicator {
                    display: none;
                    &.--focused {
                        display: initial;
                        fill: var(--hour-color);
                    }
                }

                .minute-indicator {
                    display: none;
                    stroke-width: 10px;
                    &.--focused {
                        display: initial;
                        fill: var(--minute-color);
                    }
                }

                .second-indicator {
                    display: none;
                    stroke-width: 10px;

                    &.--focused {
                        display: initial;
                        fill: var(--second-color);
                        &.--hidden {
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
